import { useQuery } from '@tanstack/react-query'
import isNil from 'lodash/isNil'
import { useDocuments } from '@omnea-app/fe-documents/useDocuments'

interface Props {
  filestoreId?: string
}

export const useCustomLogo = ({ filestoreId }: Props) => {
  const { getSignedUrl } = useDocuments()

  const { data: signedUrl, isLoading: isSignedUrlPending } = useQuery({
    queryKey: ['getLogoSignedUrl', filestoreId],
    queryFn: async () => {
      if (isNil(filestoreId)) return null
      const result = await getSignedUrl({
        filestoreId,
        fileName: 'logo.png',
      })
      if (!isNil(result) && typeof result === 'object' && 'notFound' in result) {
        return null
      }
      return result
    },
  })

  return {
    signedUrl,
    isSignedUrlPending,
  }
}
